document.addEventListener("DOMContentLoaded", function () {
  const input = document.getElementById("codeInput");
  const button = document.getElementById("loadProofBtn");
  const container = document.getElementById("proofContainer");
  const zoomModal = document.getElementById("zoomModal");
  const zoomedProof = document.getElementById("zoomedProof");
  const zoomCloseBtn = document.getElementById("zoomCloseBtn");
  const zoomOverlay = document.getElementById("zoomOverlay");

  // Load proof image on button click
  button.addEventListener("click", function () {
    const code = input.value.trim();
    const baseUrl = "https://cdn.shopify.com/s/files/1/0340/2849/files/";
    const imageUrl = `${baseUrl}${code}.jpg`;

    const img = document.createElement("img");
    img.src = imageUrl;
    img.alt = `Proof for ${code}`;
    img.id = "proofImg";
    img.style.width = "100%";
    img.style.height = "auto";

    img.onerror = () => {
      container.innerHTML = `<p style="color:red;">Proof not found for <strong>${code}</strong> – please review and try again.</p>`;
    };

    img.onload = () => {
      container.innerHTML = "";
      container.appendChild(img);

      // Open modal on image click
      img.addEventListener("click", function () {
        zoomedProof.src = img.src;
        zoomModal.style.display = "block";
        document.body.classList.add("modal-open");
      });
    };
  });

  // Close modal with the close button
  zoomCloseBtn.addEventListener("click", () => {
    closeModal();
  });

  // Close modal on Escape key
  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && zoomModal.style.display === "block") {
      closeModal();
    }
  });

  // Close modal on overlay click
  zoomOverlay.addEventListener("click", () => {
    closeModal();
  });

  // Reusable close modal function
  function closeModal() {
    zoomModal.style.display = "none";
    document.body.classList.remove("modal-open");
  }
});

function openModal() {
  zoomModal.style.display = "block";
  document.body.classList.add("proof-modal-open");
}

function closeModal() {
  zoomModal.style.display = "none";
  document.body.classList.remove("proof-modal-open");
}